import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Localize } from '@planity/components';
import { useTranslation } from '@planity/localization';
import { Radio } from '@planity/ui';
import styles from './accept_save_card_selector.module.scss';

export function AcceptSaveCardSelector({
	onChange,
	hasAcceptedSaveCard,
	isDisabled
}) {
	const { t } = useTranslation();
	useStyles(styles);

	const changeHandler = value => {
		!isDisabled && onChange(value);
	};

	return (
		<form className={styles.saveCard}>
			<span className={styles.label}>
				<Localize text={'onlinePayment.saveCardForFutureReuse.text'} />
			</span>
			<div className={styles.inline}>
				<Radio
					id='radio-save-card-accept'
					isChecked={hasAcceptedSaveCard === true}
					name={'partial-payment'}
					text={t('onlinePayment.saveCardForFutureReuse.yes')}
					textClassName={styles.radioLabel}
					onChange={() => changeHandler(true)}
				/>
				<Radio
					id='radio-save-card-deny'
					isChecked={hasAcceptedSaveCard === false}
					name={'partial-payment'}
					text={t('onlinePayment.saveCardForFutureReuse.no')}
					textClassName={styles.radioLabel}
					onChange={() => changeHandler(false)}
				/>
			</div>
		</form>
	);
}
